import {
  faArrowsRotate,
  faBan,
  faCalendar,
  faCalendarCheck,
  faClock,
  faFileDashedLine,
  faTypewriter,
} from '@fortawesome/pro-light-svg-icons'

const generateNavigationItems = () => ({
  sections: [
    {
      key: 'newsDesk',
      visible: true,
      items: [
        {
          href: '#/newsDesk/deadlines',
          icon: faClock,
          key: 'deadlines',
          title: 'Deadlines',
          visible: true,
        },
        {
          href: '#/newsDesk/bookings',
          icon: faCalendar,
          key: 'bookings',
          title: 'Bookings',
          visible: true,
        },
        {
          href: '#/newsDesk/requirePagination',
          icon: faFileDashedLine,
          key: 'requirePagination',
          title: 'Require Pagination',
          visible: true,
        },
        {
          href: '#/newsDesk/preflighting',
          icon: faArrowsRotate,
          key: 'preflighting',
          title: 'Preflighting',
          visible: true,
        },
        {
          href: '#/newsDesk/cancelledItems',
          icon: faBan,
          key: 'cancelledItems',
          title: 'Cancelled Items',
          visible: true,
        },
        {
          href: '#/newsDesk/inspections',
          icon: faCalendarCheck,
          key: 'inspections',
          title: 'Inspections',
          visible: true,
        },
        {
          href: '#/newsDesk/editorials',
          icon: faTypewriter,
          key: 'editorials',
          title: 'Editorials',
          visible: true,
        },
      ],
    },
  ],
})

export default generateNavigationItems
